<script>
import NavigationWrapper from "@/components/NavigationWrapper";

export default {
  // Included components
  components: {
    NavigationWrapper,
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item active>Help</b-breadcrumb-item>
    </template>
    <h1 class="mb-3">Help</h1>
    <b-card>
      For more help, see the
      <b-link to="/help/faq">FAQ</b-link>
      or
      <b-link v-b-modal.support-modal>contact support</b-link>
      .
    </b-card>
  </NavigationWrapper>
</template>
